const axios = require('axios');

async function getDashboardMetrics(days = 30) {
  const resData = await axios.get('/api/v1/admin/metrics', { params: { days } });
  return resData.data;
}

module.exports = { getDashboardMetrics };
